module.exports = __webpack_public_path__ + "img/wood-block--refine--step2.svg";